import React, { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import transition from "./transition";
import "../style/Work.css";
import SideMenu from "./SideMenu";


const categories = [
    {
        name: "Music Videos",
        artists: [
            { name: "Corbyn Besson", videos: ["NYMMDQGVgP0"]},
            { name: "Omarion", videos: ["BMFna9dLK4Q", "Ji-acxYYE_4"] },
            { name: "Ciara", videos: ["xnumI3_qt-w", "5HsRDuRSgQQ", "3OByv5luEjc"] },
            { name: "DaniLeigh", videos: ["7Nbv3reNErw"] },
            { name: "Austin Mahone", videos: ["lDjYo-86zPE", "3ocZK4i529M"] },
            { name: "Lil Nas X", videos: ["c-yRN55iaQY"] },
            { name: "Tee Grizzley", videos: ["wc8UEezouyg", "Oc5vZV-ORLk"] },
            {
                name: "Chris Brown",
                videos: [
                    "6L_k74BOLag", "zMlDG1E2xSU", "TMcbFHYH-Ic", "BloAzLIcRyE", "ep523mpr78k",
                    "wWR0VD6qgt8", "xqdaVkJSNWg", "_t0qtSKOpO4", "qxTqRFSWmm8", "CtuFaOqiots",
                    "pfxyk1glEq4", "BLN2nsm1w6w", "_xnIWT9PpK4", "hLpAZ8_BZS4", "_Gcaa7rGKr8",
                    "dPhwbZBvW2o", "i_vMte-NHkY", "odgvsMFSIo8", "r7CWEE3ZAWs", "y6fThXQPT6I",
                    "VfVmCnCP7Mg", "BmLSua7LPR8", "QdnvoWyoiY0", "M020Ajhkojg", "GTexe8c0eqw",
                    "mH76VvWkNwA", "Fq0xEpRDL9Q"
                ]
            },
            { name: "Ne-Yo", videos: ["e5WC-9TbjjQ"] },
            { name: "Usher", videos: ["Z9eMk051dYg", "3w0yqAdJ1iY"] },
            { name: "Ar'mon & Trey", videos: ["osGl1krYP-g"] },
            { name: "Lil Dicky", videos: ["aZla1ttZHaw"] },
            { name: "A1 LaFlare", videos: ["dOdW5oFKlLI"] },
        ],
    },
    {
        name: "Television",
        artists: [
            { name: "Ciara", videos: ["FwAg5KnO7eQ", "N01TrsdVMBY", "LVvCH2iMhE8"] },
            { name: "Lil Nas X", videos: ["Q9Vjvz1NPN8"] },
            { name: "Lil Baby", videos: ["PRYMTS37kng"] },
            { name: "Li Angelo Ball", videos: ["1ynezA5B9YM"] },
            { name: "21 Savage", videos: ["dNIJmlhgqGk"] },
            { name: "Fivio Foreign & Lil Tjay", videos: ["11fmQlcMB7Q"] },
            { name: "Jack Harlow", videos: ["vvcW6oEbdtg"] },
            { name: "Chris Brown", videos: ["tO2UMyXKd2s"] },
        ],
    },
    {
        name: "BTS Footage",
        artists: [
            {
                name: "Chris Brown",
                videos: [
                    "5pF4Hv3E1MU", "O6knMHWU4is", "mKp8JCOZnvg", "ID-AuFJ3lfI"
                ]
            },
            { name: "Austin Mahone", videos: ["LkM6URn_1hk"] }
        ],
    },
    {
        name: "Interviews",
        artists: [
            {
                name: "Ourselves Podcast",
                videos: [
                    "aiYDnNScamY"
                ]
            }
        ],
    }
];


const Work = () => {
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 480);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleCategoryChange = (category) => {
        setSelectedCategory((prev) => (prev === category ? null : category));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest(".side-menu") &&
                !event.target.closest(".category-name") &&
                !event.target.closest(".thumbnail-container")
            ) {
                if (selectedCategory) {
                    setSelectedCategory(null); // Close the menu first
                }
            }
        };

        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [selectedCategory]);

    return (
        <div className={`work-container ${selectedCategory ? "category-active" : ""}`}>
            {isMobile && selectedCategory && (
                <button className="return-button work-return" onClick={() => setSelectedCategory(null)}>
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                </button>
            )}

            {/* Left Side: Category List */}
            <div className="category-list">
                {categories.map((category, index) => (
                    <a
                        key={index}
                        className={`category-name ${selectedCategory === category ? "selected" : ""}`}
                        onClick={() => handleCategoryChange(category)}
                    >
                        {category.name}
                    </a>
                ))}
            </div>

            {/* Side Menu with Exit/Enter Animations */}
            <AnimatePresence>
                {selectedCategory && <SideMenu category={selectedCategory} />}
            </AnimatePresence>
        </div>
    );
};

export default transition(Work);